import React, { useState, useRef } from "react";
import { Menu, MenuItem, Button } from "@material-ui/core";
// import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";
import { useStyles } from "../styles";
import { get, upperCase } from "lodash";
import { checkinDetailSelector } from "Recoil/Checkins/selector";
import { useRecoilState, useRecoilValue } from "recoil";
// import { useLazyQuery } from "@apollo/client";
// import { checkinOverviewDownload } from "GraphQL/queries/checkin/download";
import DownloadIcon from "Assets/images/download-icon.svg";
import LoadingWidget from "Components/widgets/LoadingWidget";
import { useCheckinDetails } from "Hooks/checkin/useCheckinDetails";
import { downloadLoaderState } from "Recoil/Checkins/atom";

const DownloadDropDown = ({ selectedFrequency }) => {
  const classes = useStyles();
  // containerRef used to unblock scroll issue
  const containerRef = useRef();
  const checkinDetail = useRecoilValue(checkinDetailSelector);
  const { id, checkInType } = checkinDetail;
  // const [anchorEl, setAnchorEl] = useRecoilState(anchorElState);
  const [anchorEl, setAnchorEl] = useState(null);
  const [downloadLoader, setDownloadLoader] =
    useRecoilState(downloadLoaderState);
  // const [downloadLoader, setDownloadLoader] = useState(downloadLoaderState);
  const { downloadCheckinOverload } = useCheckinDetails();
  const fileType = ["Excel"]; //'PDF',
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const [downloadCheckinOverload] = useLazyQuery(checkinOverviewDownload, {
  //   fetchPolicy: FETCH_POLICY.networkOnly,
  //   onCompleted: (data) => {
  //     handleClose();
  //     const a = document.createElement("a");
  //     a.href = get(data, "checkinOverviewDownload.file", "");
  //     a.download = get(data, "checkinOverviewDownload.fileName", "");
  //     a.click();
  //     setDownloadLoader(false);
  //   },
  // });

  const downloadSelectedFile = (type) => {
    setDownloadLoader(true);
    downloadCheckinOverload({
      variables: {
        checkinId: id,
        downloadType: upperCase(type),
        sequenceNo: get(selectedFrequency, "checkinSequenceNo", 0),
      },
    });
  };

  return (
    <div ref={containerRef}>
      {downloadLoader ? (
        <LoadingWidget color="gray" />
      ) : (
        <>
          <Button
            data-testid="btn"
            size="small"
            // disabled={true}
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleClick}
            color="primary"
            // endIcon={<ExpandMoreOutlinedIcon />}
          >
            <>
              Download
              <img
                src={DownloadIcon}
                alt="download"
                width="20px"
                className="ml5"
              />
            </>
          </Button>

          <Menu
            container={containerRef.current}
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            className={classes.menu}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            getContentAnchorEl={null}
          >
            {fileType.map((type) => (
              <MenuItem
                data-testid="menu"
                onClick={() => {
                  handleClose();
                  downloadSelectedFile(type);
                }}
              >
                {type}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </div>
  );
};

export default DownloadDropDown;
